import React from 'react';
import { useI18nContext } from '@procore/core-react';
import { sendAnalytics } from '../../utils';
import {
  FooterCard,
  FooterContent,
  FooterDescription,
  FooterTitle,
  EmailText,
  EmailLink,
  FooterButton,
} from './SectionFooter.styles';

const SectionFooter = () => {
  const i18n = useI18nContext();

  const handleJoinDiscussion = () => {
    sendAnalytics(
      'click',
      'Button',
      'Join the Discussion',
      'join_discussion.clicked'
    );
    window.open(
      'https://community.procore.com/s/topic/0TO2T000000c9HTWAY/integrations-app-marketplace',
      '_blank'
    );
  };

  return (
    <FooterCard data-testid="questions-section">
      <FooterContent>
        <FooterTitle>{i18n.t('appDetails.questions.title')}</FooterTitle>
        <FooterDescription>
          {i18n.t('appDetails.questions.description')}
        </FooterDescription>
        <FooterButton intent="primary" size="lg" onClick={handleJoinDiscussion}>
          {i18n.t('appDetails.questions.joinDiscussion')}
        </FooterButton>
        <EmailText>
          {i18n.t('appDetails.questions.foundIssue')}{' '}
          <EmailLink
            href={`mailto:${i18n.t('appDetails.questions.supportEmail')}`}
          >
            {i18n.t('appDetails.questions.supportEmail')}
          </EmailLink>
        </EmailText>
      </FooterContent>
    </FooterCard>
  );
};

export default SectionFooter;
